<template>
  <DxPopup
    :visible.sync="localPopupVisible"
    :width="'75%'"
    :height="800"
    :showTitle="true"
    title=""
    :dragEnabled="true"
    :closeOnOutsideClick="false"
    :wrapperAttr="{ class: 'gc-popup-stocktake-count' }"
    :titleTemplate="'titleTemplate'"
  >
    <template #titleTemplate>
      <div class="custom-title">
        <span class="title-primary">{{ popupTitles.primary }}</span>
        <span class="title-secondary"> {{ popupTitles.secondary }}</span>
      </div>
    </template>
    <div class="count-content css-v2">
      <div class="gc-header-form">
        <div>
          <span>Branch</span>
        </div>
        <div>
          <span class="title-primary">{{ countData.BranchDescription }}</span>
          <span class="title-secondary">{{ countData.BranchCode }}</span>
        </div>
      </div>
      <div class="gc-details-grid">
        <dx-data-grid
          :height="610"
          :columns="getColumns"
          :data-source="getDataSource"
          ref="dx-data-grid-count"
          :key-expr="'ID'"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          :column-chooser="{ enabled: false }"
        >
          <DxSearchPanel :visible="false" />
          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>
      </div>
    </div>
    <div class="footer">
      <DxButton
        :width="100"
        text="Close"
        type="default"
        styling-mode="contained"
        @click="onPopupHiding()"
      />
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue";
import { StocktakeReviewService } from "../../_services/api/inventory/stocktake-review.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { StocktakeCountService } from "../../_services/api/inventory/stocktake-count.service";
import { FeatureStorage } from "../../_services/storage";

export default {
  components: {
    DxPopup,
  },
  props: {
    popupVisible: {
      type: Boolean,
    },
    countData: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: () => {},
    },
    recallFromCount: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      localPopupVisible: this.popupVisible,
      fileData: [],
      popupTitles: {
        primary: undefined,
        secondary: undefined,
      },
      countUpdated: false,
    };
  },
  created() {
    this.popupTitles.primary = this.countData.ProductCode;
    this.popupTitles.secondary = this.countData.ProductDescription;
  },
  watch: {
    popupVisible(val) {
      this.localPopupVisible = val;
    },
  },
  methods: {
    onPopupHiding() {
      this.localPopupVisible = false;
      this.$emit("update:popupVisible", false);

      this.recallFromCount(this.countUpdated);
    },
    async reverseCountLine(e) {
      this.showLoading(true);
      let lineData = e.row.data;

      let payload = {
        ReferenceNo: "",
        BatchNo: lineData.BatchNo,
        BinLocationCode: lineData.BinLocationCode,
        BranchCode: lineData.BranchCode,
        Count:
          lineData.Count > 0
            ? -Math.abs(lineData.Count)
            : Math.abs(lineData.Count),
        ProductCode: lineData.ProductCode,
        StocktakeCode: lineData.StocktakeCode,
        SupplierCode: lineData.SupplierCode,
        UseByDate: lineData.UseByDate,
      };

      await StocktakeCountService.saveStocktakeCount(payload)
        .then((result) => {
          if (result) this.showLoading(false);
          this.countUpdated = true;

          var dataGrid = this.$refs["dx-data-grid-count"].instance;
          dataGrid.refresh();
        })
        .catch((error) => {
          this.showLoading(false);
          this.displayServerError(error, "Stocktake Count Commit Failed");
        });
    },
  },
  computed: {
    getColumns() {
      return [
        {
          caption: "UM",
          dataField: "UnitOfMeasureCode",
          width: ColumnWidth.UnitOfMeasure.width,
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          allowEditing: false,
        },
        {
          caption: "Ref No",
          dataField: "ReferenceNo",
          width: ColumnWidth.InvoiceRef.width,
          minWidth: ColumnWidth.InvoiceRef.minWidth,
          allowEditing: false,
        },
        {
          caption: "Bin",
          dataField: "BinLocationCode",
          width: ColumnWidth.InvoiceRef.width,
          minWidth: ColumnWidth.InvoiceRef.minWidth,
        },
        {
          caption: "Batch",
          dataField: "BatchNo",
          width: ColumnWidth.BatchNo.width,
          minWidth: ColumnWidth.BatchNo.minWidth,
        },
        {
          caption: "Supplier",
          dataField: "SupplierCode",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.SupplierName}
                        </span>
                      <span class="record-secondary gc-grid-code">
                        ${info.data.SupplierCode}
                      </span>
                    </div>`);
          },
        },
        {
          caption: "Count",
          dataField: "Count",
          width: ColumnWidth.Price2DecimalPoints.width,
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          format: "###,##0.00",
          cellTemplate: "Decimal",
        },
        {
          screenField: "DateIn",
          caption: "Count Date",
          dataField: "CountDate",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          format: "dd MMM yyyy",
        },
        {
          caption: "Count By",
          dataField: "CreatedBy",
          width: 120,
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Reversal",
              icon: "repeat",
              visible: true,
              onClick: async (e) => {
                let confirmReverse = await this.$confirm(
                  "Are you sure you want to reverse this item? This action cannot be undone.",
                  "Reversal Confirmation"
                );

                if (confirmReverse) this.reverseCountLine(e);
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 40,
          minWidth: 40,
          visible: this.getUserAccess,
        },
      ];
    },

    getUserAccess() {
      return (
        this.countData.Status != "X" &&
        this.countData.Status != "C" &&
        FeatureStorage.checkPermission("StocktakeManagement", "create")
      );
    },
    getDataSource() {
      return StocktakeReviewService.dataSourceConfig(
        "api/StocktakeCountReview",
        {
          filter: [
            ["StocktakeCode", "=", parseInt(this.countData.StocktakeCode)],
            "and",
            ["BranchCode", "=", `${this.countData.BranchCode}`],
            "and",
            ["ProductCode", "=", `${this.countData.ProductCode}`],
            "and",
            ["Count", "<>", 0],
          ],
          key: "RecordId",
          keyType: {
            RecordId: "Guid",
          },
          sort: [{ selector: "ProductCode", asc: true }],
        }
      );
    },
  },
};
</script>
<style lang="scss">
.gc-popup-stocktake-count {
  .dx-popup-content {
    background-color: #e1e1e9c7;
    padding: 12px !important;

    .gc-header-form {
      background-color: white;
      padding: 12px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      > div:last-child {
        padding-left: 20px;
        span {
          font-size: 12px !important;
        }
      }
    }
  }
}
</style>
